import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { addNotificationAction } from '../../action/notifications/notifications';

import { post } from '../../api/api';

export const createMergeIntegration = (orgId: number, publicToken: any) =>
  createGenericDispatcher({
    name: 'CREATE_MERGE_INTEGRATION',
    loadFunction: () =>
      post('/merge/account-token', {
        body: JSON.stringify({ orgId, publicToken }),
      }),
    args: { orgId },
    onSuccess: (dispatch) => {
      dispatch(
        addNotificationAction({
          key: `create-merge-integration-${orgId}`,
          message: 'Integration successfully created',
        }),
      );
    },
  });
